
import React, { PropTypes } from 'react';

import {
  Alert,
  Button
} from 'react-bootstrap';

const AlertForm = ({
  visible, msg, handleAlertDismiss,
  bsStyle = 'danger',
  messageTitle = 'Oh, snap! There is at least one error!'
} = {}) => {
  if (visible) {
    return (
      <Alert
        bsStyle={bsStyle}
        onDismiss={handleAlertDismiss}
      >
        <h4><strong>{messageTitle}</strong></h4>
        <p>{msg}</p>

        <hr />

        <p>
          <Button bsStyle="primary" onClick={handleAlertDismiss}>
            Dismiss Alert
          </Button>
        </p>
      </Alert>
    );
  }

  return null;
};

AlertForm.propTypes = {
  msg: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  handleAlertDismiss: PropTypes.func.isRequired,

  bsStyle: PropTypes.string,
  messageTitle: PropTypes.string
};

export default AlertForm;



// WEBPACK FOOTER //
// ./src/components/contact/AlertForm.js